import React from "react";

/**
 * Selected product's text description
 *
 * @param {Object} selectedProduct  Current selected product
 * @returns
 */
export default function ProductDescription({ selectedProduct }) {
  return (
    <>
      {selectedProduct.description ? (
        <p
          dangerouslySetInnerHTML={{
            __html: selectedProduct.description,
          }}
        ></p>
      ) : (
        <>
          <p>
            Personalize your home or create a special gift with your favorite photo memories or
            artwork with a custom canvas print made with exceptional quality and rich texture. Start by
            uploading your favorite photo, then explore our custom, hand-made canvas prints in sizes up
            to 60" x 60". Finish your print with a solid wood floating frame in your choice of finish for
            a beautiful piece that will last for years.
          </p>
          <ul>
            <li>Museum quality cotton/poly blend canvas</li>
            <li>Water and fade resistant</li>
            <li>Sizes up to 60" x 60"</li>
            <li>Available wooden floating frames in a variety of colors</li>
          </ul>
        </>
      )}
    </>
  );
}
